// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chevron-down.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chevron-down',
  version: 'outline',
  paths: [
    {
      id: 'chevron',
      d: 'm19.5 8.25-7.5 7.5-7.5-7.5',
    },
  ],
}
